export const COLOR_EMG_QUERY_PARAM = 'color_emg';
export const PRODUCT_EMG_QUERY_PARAM = 'productEMG';
export const SKU_QUERY_PARAM = 'sku';
export const JOB_QUERY_PARAM = 'job';
export const COLOR_CODE_QUERY_PARAM = 'color_code';
export const COLOR_PALETTE_QUERY_PARAM = 'palette_code';
export const IS_SAMPLE_QUERY_PARAM = 'is_sample';
